import WithDriverIconPopup from '../WithDriverIconPopup';

function DriverMarker({ backgroundColor, borderColor }) {
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ transform: 'scale(2.0)' }}>
      <g filter="url(#filter0_d)">
        <path
          d="M19.6333 8.73332C19.4445 8.48152 19.1481 8.33332 18.8333 8.33332H17.8333V6.66666C17.8333 6.11437 17.3856 5.66666 16.8333 5.66666H7.49999C6.21437 5.66666 5.16666 6.71437 5.16666 7.99999V15.3333C5.16666 15.8856 5.61437 16.3333 6.16666 16.3333H6.67018C7.08131 17.4994 8.19181 18.3333 9.49999 18.3333C10.8082 18.3333 11.9187 17.4994 12.3298 16.3333H14.6702C15.0813 17.4994 16.1918 18.3333 17.5 18.3333C18.8082 18.3333 19.9187 17.4994 20.3298 16.3333H20.8333C21.3856 16.3333 21.8333 15.8856 21.8333 15.3333V12C21.8333 11.7836 21.7631 11.5731 21.6333 11.4L19.6333 8.73332ZM9.49999 15C9.68561 15 9.83332 15.1477 9.83332 15.3333C9.83332 15.5189 9.68561 15.6667 9.49999 15.6667C9.31437 15.6667 9.16666 15.5189 9.16666 15.3333C9.16666 15.1477 9.31437 15 9.49999 15ZM14.5 13H11.3747C10.8677 12.5889 10.221 12.3333 9.49999 12.3333C9.14619 12.3333 8.81028 12.3949 8.49999 12.5061V8.99999H14.5V13ZM17.5 15C17.6856 15 17.8333 15.1477 17.8333 15.3333C17.8333 15.5189 17.6856 15.6667 17.5 15.6667C17.3144 15.6667 17.1667 15.5189 17.1667 15.3333C17.1667 15.1477 17.3144 15 17.5 15Z"
          fill={backgroundColor || '#05A792'}
          stroke={borderColor}
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.166656"
          y="0"
          width="26.6667"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
export default WithDriverIconPopup(React.memo(DriverMarker));
